import React from 'react';
import Box from '@material-ui/core/Box';
import PieChart, { PieChartData } from './PieChart';

interface PieChartsProps {
  data: PieChartData[];
}

const PieCharts = (props: PieChartsProps) => (
  <Box display="flex" alignItems="center" justifyContent="space-around" flexWrap="wrap" mb={2}>
    {props.data.map(data => (
      <PieChart data={data} />
    ))}
  </Box>
);

export default PieCharts;
